import { connect } from 'react-redux';
import * as ComponentFunctions from './ChildConsumption.List.Functions';
import { useEffect, useState } from 'react';
import { createTableColumn, TableCellLayout, TableColumnDefinition, DataGrid, DataGridHeader, DataGridRow, DataGridHeaderCell, DataGridBody, DataGridCell, Spinner } from '@fluentui/react-components';
import { ProtocolConsumption } from '../../../models/Entities/Protocols/ProtocolConsumption';
import ConsumptionDetailsCompoment from '../ConsumptionDetails/ConsumptionDetails.Component';
import { useTranslation } from 'react-i18next';
import * as ConsumptionListFunctions from '../ConsumptionList/ConsumptionList.Functions';

const ChildConsumptionListComponent = (props: ComponentFunctions.Props) => {
  const { t } = useTranslation();
  // No need to fetch visit-specific data; list derives from protocol consumptions filtered by ParentGroupingId
  useEffect(() => {
    if (props.ProtocolId && (props.protocol === null || props.protocol === undefined)) {
      // Ensure protocol is loaded
      props.GetMedicalProtocolById(props.ProtocolId);
    }
    // Also request consumptions filtered by ParentGroupingId from server
    if (props.ProtocolId && props.ParentGroupingId) {
      props.GetAllProtocolConsumptionsByProtocol(
        props.ProtocolId,
        1,
        100,
        {
          SelectedConsumptions: [],
          SelectedProtocolPatients: [],
          SelectedContractConcepts: [],
          SelectedCurrencys: '',
          SelectedContractStages: [],
          SelectedPractitioners: [],
          SelectedStatus: [],
          SelectedProtocols: [],
          SelectedSettlements: [],
          SelectedDateRange: [undefined, undefined],
          FilterText: undefined,
          showGroupedByVisit: false,
          GroupId: props.ParentGroupingId,
        }
      );
    }
  }, [props.ProtocolId, props.ParentGroupingId]);

  const [selectedConsumption, setSelectedConsumption] = useState<ProtocolConsumption | null>(null);
  const [isInformationPanelOpen, setIsInformationPanelOpen] = useState(false);

  const onInformationPanelDismiss = () => {
    setSelectedConsumption(null);
    setIsInformationPanelOpen(false);
  };

  const columns: TableColumnDefinition<ProtocolConsumption>[] = [
    createTableColumn<ProtocolConsumption>({
      columnId: 'status',
      compare: (a, b) => (props.ProviderId ? a.costStatus - b.costStatus : a.status - b.status),
      renderHeaderCell: () => <span>{t('consumptionList.headers.status')}</span>,
      renderCell: (item: ProtocolConsumption) => (
        <TableCellLayout>
          {item.ischangingStatus || item.isDeleting || item.isSaving ? (
            <Spinner size="extra-tiny" />
          ) : (
            <div className={'status-mark ' + ConsumptionListFunctions.GetStatusDescription(props.ProviderId ? item.costStatus : item.status).class}></div>
          )}
        </TableCellLayout>
      ),
    }),
    createTableColumn<ProtocolConsumption>({
      columnId: 'concept',
      compare: (a, b) => a.serviceName.localeCompare(b.serviceName),
      renderHeaderCell: () => <span>Concepto</span>,
      renderCell: (item: ProtocolConsumption) => (
        <TableCellLayout>
          <strong>{item.serviceName}</strong>
        </TableCellLayout>
      ),
    }),
    createTableColumn<ProtocolConsumption>({
      columnId: 'totalAmount',
      compare: (a, b) => a.totalAmount - b.totalAmount,
      renderHeaderCell: () => <span>Total</span>,
      renderCell: (item: ProtocolConsumption) => (
        <TableCellLayout>
          <strong>{item.totalAmount?.toLocaleString('es-AR', { style: 'currency', currency: item.currencyCode?.toUpperCase() }) || '0.00'}</strong>
        </TableCellLayout>
      ),
    }),
    createTableColumn<ProtocolConsumption>({
      columnId: 'pending',
      compare: (a, b) => a.pendingAmount - b.pendingAmount,
      renderHeaderCell: () => <span>Pendiente</span>,
      renderCell: (item: ProtocolConsumption) => (
        <TableCellLayout>
          <strong>{item.pendingAmount?.toLocaleString('es-AR', { style: 'currency', currency: item.currencyCode?.toUpperCase() }) || '0.00'}</strong>
        </TableCellLayout>
      ),
    }),
  ];

  const Forms = (
    <>
      {selectedConsumption && (
        <ConsumptionDetailsCompoment
          ProtocolId={selectedConsumption.protocolId}
          ParentProtocolConsumptionId={props.CosnumptionId}
          ProtocolConsumptionId={selectedConsumption.id}
          visitId={undefined}
          isOpen={isInformationPanelOpen}
          onClose={onInformationPanelDismiss}
        />
      )}
    </>
  );

  return (
    <>
    <DataGrid
      items={props.Consumptions}
      columns={columns}
      sortable
    >
      <DataGridHeader>
        <DataGridRow>
          {({ renderHeaderCell }) => (
            <DataGridHeaderCell>
              {renderHeaderCell()}
            </DataGridHeaderCell>
          )}
        </DataGridRow>
      </DataGridHeader>
      <DataGridBody<ProtocolConsumption>>
        {({ item, rowId }) => (
          <DataGridRow<ProtocolConsumption> key={rowId}>
            {({ renderCell }) => (
              <DataGridCell onClick={(e: any) => {
                e.stopPropagation();
                setSelectedConsumption(item);
                setIsInformationPanelOpen(true);
              }}>
                {renderCell(item)}
              </DataGridCell>
            )}
          </DataGridRow>
        )}
      </DataGridBody>
    </DataGrid>
    {Forms}
    </>
  );
};

export default connect(
  ComponentFunctions.mapStateToProps,
  ComponentFunctions.mapDispatchToProps
)(ChildConsumptionListComponent as any);
